// extracted by mini-css-extract-plugin
export default {"root":"RaildaysUiControls_root__Me-eP","layoutPlaceholderIcon":"RaildaysUiControls_layoutPlaceholderIcon__njtFs"};